export default __webpack_public_path__ + "static/media/desk03.b3fd70c0.jpg";